import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Translate from "@material-ui/icons/Translate";
import ExitIcon from "@material-ui/icons/ExitToApp";
import SearchIcon from "@material-ui/icons/SearchOutlined";
import { Tooltip, Divider } from "@material-ui/core";
import InvisionLogo from "../images/mipmap-hdpi/ic_launcher.png";
import MyAutoSuggest from "./MyAutoSuggest";

import { Link } from "react-router-dom";

const styles = {
  root: {
    flexGrow: 1
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: 20
  }
};

class ButtonAppBar extends React.Component {
  render() {
    const { classes } = this.props;
    //console.log('appbar', this.props.actionfunc)
    return (
      <div className={classes.root}>
        <AppBar position="static" color="default" elevation={0}>
          <Toolbar>
            <div className={classes.menuButton}>
              <Button component={Link} to={"/home"}>
                <img
                  className={"logo-size"}
                  //src="https://invisionweb.in/site/static/media/invision.2acab5b0.png"
                  src={InvisionLogo}
                />
              </Button>
            </div>
            <Typography variant="h6" color="inherit" className={classes.grow}>
              {/* <IconButton>
          <Translate />
          </IconButton> */}

              <Button component={Link} to={"/home"}>
                <Typography variant="h6">আখৰ</Typography>
              </Button>
            </Typography>

            {/*<Button size="small" color="inherit" variant={"outlined"} onClick={this.props.actionfunc}>*/}
            {/*Log out*/}
            {/*</Button>*/}

            {/*<Tooltip title="Search word" placement="top">*/}
            {/*<IconButton*/}
            {/*color="default"*/}
            {/*aria-label="Search word"*/}
            {/*onClick={() => {}}*/}
            {/*>*/}
            {/*<SearchIcon fontSize={"small"}/>*/}
            {/*</IconButton>*/}
            {/*</Tooltip>*/}

            {/* this.props.actionfunc !== undefined && <MyAutoSuggest /> */}

            {this.props.actionfunc !== undefined && (
              <IconButton aria-label="Log out" onClick={this.props.actionfunc}>
                <ExitIcon fontSize="small" />
              </IconButton>
            )}

            {/*this.props.actionfunc === undefined && (
              <a href="http://invisionweb.in">
                <img
                  className={"logo-size"}
                  src="https://invisionweb.in/site/static/media/invision.2acab5b0.png"
                />
              </a>
            )*/}

            <a href="http://invisionweb.in">
              <img
                className={"logo-size"}
                src="https://invisionweb.in/site/static/media/invision.2acab5b0.png"
              />
            </a>
          </Toolbar>

          {/*this.props.actionfunc !== undefined && <Divider />*/}
        </AppBar>
      </div>
    );
  }
}

ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ButtonAppBar);
